import { ObjectHelpers } from "../../helpers/object-helpers";
import { ChartType } from "../enum/chart-type.enum";
import { AdvancedOEPStateModel } from "./advanced-oep-state.model";
import { ChartSettingsPopupModel } from "./chart-settings-popup.model";
import { ChartStyleColorModel } from "./chart-style-color.model";
import { ChartStylePIPSettingsModel } from "./chart-style-pip-settings.model";
import { ChartStylePrimitiveChartSettingsModel } from "./chart-style-primitive-chart-settings.model";
import { ChartYAxisStateModel } from "./chart-y-axis-state-model";

export class ChartStyleSettingsModel {
    public name = '';
    public chartType: ChartType = ChartType.Candlestick;
    public chartTypeLineWidth = 1;
    public selectedLineColor = new ChartStyleColorModel();
    public selectedUpCandleColor = new ChartStyleColorModel();
    public selectedDownCandleColor = new ChartStyleColorModel();
    public selectedOutlineWickColor = new ChartStyleColorModel();
    public selectedDateTextColor = new ChartStyleColorModel();
    public selectedPriceTextColor = new ChartStyleColorModel();
    public selectedStatusLineTextColor = new ChartStyleColorModel();
    public selectedChartGradientColor = new ChartStyleColorModel();
    public selectedChartBackgroundColor = new ChartStyleColorModel();
    public selectedDisplayPriorDayCloseColor = new ChartStyleColorModel();
    public preMarketColor = new ChartStyleColorModel();
    public postMarketColor = new ChartStyleColorModel();
    public watermarkColor = new ChartStyleColorModel();
    public earningRectangleColor = new ChartStyleColorModel();
    public watermarkOpacity = 34;
    public monthDayPattern = '';
    public dateSeparator = '';
    public decimalSeparator = '';
    public thousandSeparator = '';
    public timeZoneId = '';
    public isDisplayPriorDayCloseChecked = false;
    public isGradientChecked = false;
    public isGradientAreaColorChecked = false;
    public isOneColor = false;
    public isDarkTheme = false;
    public showPreMarket = false;
    public isPreMarketDisabled = false;
    public showPostMarket = false;
    public isPostMarketDisabled = false;
    public showSmartRiskLevel = false;
    public crossHairsEnabled = false;
    public gridLinesEnabled = false;
    public showWatermark = false;
    public isComparisonSymbolPercentageMode = false;
    public curvedLineDisabled = false;
    public getPrePostLastPriceDisabled = false;
    public startDrawingToolsExpanded = false;
    public highChartIndicatorsEnabled = false;
    public highChartIndicators = '';
    public extraFutureBarCount = 0;
    public zoomLevel = 0;
    public startTimeT = 0;
    public emojiDrawingToolsEnabled = false;
    public emojiDefaultSize = 0;
    public emojiFontSizes = '';
    public pnpPosition = '';
    public pnpExpanded = false;
    public pnpInitialed = false;
    public pnpEnabled = false;
    public pnpPriceAlertEnabled = false;
    public pnpChangePercentEnabled = false;
    public zoomEnabled = true;
    public supportsFutureScrolling = false;
    public rightEdgePaddingSaveEnabled = false;
    public futureScrollingEnabled = false;
    public futureScrollingScrollStopEnabled = true;
    public futureScrollingBarCount = 0;
    public futureScrollingMinDisplayBarCount = 0;
    public goLevelColors: Array<string> = [];
    public rightEdgePaddingBarsDefault = 3;

    public marketingChartAreaFillHexColor = new ChartStyleColorModel();
    public marketingChartGradientHexColor  = new ChartStyleColorModel();

    public timeframeColor: ChartStyleColorModel | null = null;
    public singleStockInfoBackgroundColor: ChartStyleColorModel | null = null;
    public selectedAreaChartUpColor: ChartStyleColorModel | null = null;
    public selectedAreaChartDownColor: ChartStyleColorModel | null = null;

    public companyProfileState = '';
    public singleStockBaseColor = '';
    public singleStockState = '';
    public singleStockSupported = false;
    public singleStockEnabled = false;
    public singleStockNoBackground = false;
    public singleStockAutoCollapseHeight = 450;
    public singleStockBGPercent = 7;
    public singleStockSeparatorDarkColor = '';
    public singleStockSeparatorLightColor = '';

    public changeFromCloseUpColorLight = '';
    public changeFromCloseDownColorLight = '';
    public changeFromCloseUpColorDark = '';
    public changeFromCloseDownColorDark = '';

    public lastPriceUpColorLight = '';
    public lastPriceDownColorLight = '';
    public lastPriceUpColorDark = '';
    public lastPriceDownColorDark = '';

    public smallChartChangeHeight = 350;
    public smallChartChangeWidth = 500;

    public chartStylePIPSettings: ChartStylePIPSettingsModel | null = null;
    public chartSettingsPopupModel = new ChartSettingsPopupModel();
    public chartYAxisStateModel = new ChartYAxisStateModel();

    public previewChartBackgroundTrasparent = false;

    public newTradeUITop: number | null = null;
    public newTradeUILeft: number | null = null;
    public newTradeUIOpen = false;
    public newTradeUIType = '';
    public newTradeUITIF = '';
    public newTradeUIAccount = '';
    // public newTradeUIQuantity = 1000;

    public emaCloudEnabled = false;
    public emaCloudDisplayBuySellFlags = true;
    public emaCloudDisplayOnlyLastTwoTrades = true;
    public emaCloudSectionCount = 3;

    public pnpTimeframeRangeEnabled = false;

    public mobileZoomEnabled = true;
    public marketingChartTimeframeAutoExpand = false;

    public primitiveMode = false;
    public primitiveChartSettings: ChartStylePrimitiveChartSettingsModel | null = null;

    public exitOrderHoverEffectDisabled = false;
    public exitOrderDisplayBluePlotline = true;
    
    public persistPositionShareQuantity = true;

    public zoomAndScrollEnabled = false;
    public zoomAndScrollAbsoluteHeight = 36;

    public yAxisPanningEnabled = false;
    public chartSettingsPopupEnabled = false;
    
    public tradeOrderEntrySupported = false;
    public tradeOrderEntryEnabled = false;
    public plusMenuEnabled = false;
    public buySellSyncTradeSizeEnabled = false;
    
    public webBasedIndicatorManagerSupported = false;
    public companyProfileSupported = false;
    public totalVolumeDisplayTopRight  = false;

    public chartSettingsWorkflowSupported = false;
    public alertsOnChartSupported = false;
    public alertsTestModeEnabled = false;
    public constantResistanceSupported = false;

    public moneyMachineSupported = false;
    public isMoneyMachineRunning = false;
    public moneyMachineRemoveMessage = '';
    public moneyMachineTradeWaveStopLossCanMoveLower = false;
    public moneyMachineTrailingStopStopLossCanMoveLower = false;
    
    public constantResistanceViewPaddingPercent = 0;
    public constantResistanceStartingOpacity = 0;
    public constantHoverOpacity = 0;
    public constantResistancePanThreshold = 0;
    public constantResistanceDistancePixelsThreshold = 0;
    public constantResistanceChartCompressEnabled = false;
    public constantResistanceEnabled = false;

    public tradeWaveName = '';
    
    public advancedOEPPopoutMode = false;
    public advancedOEPSupported = false;
    public advancedOEPEnabled = false;
    public advancedOEPTOSCount = 100;
    public advancedOEPBasicTradeButtonText = '';
    public advancedOEPAdvancedTradeButtonText = '';
    public advancedOEPTOSDevModeEnabled = false;
    public advancedOEPUseCurrentTNSPrice = false
    public chartLastUseCurrentTNSPrice = false
    public changeFromCloseUseTradeQuote = false
    public advancedOEPTOSFourDecimalLessThan = 5;
    public advancedOEPOpen = false
    public advancedOEPStateModel = new AdvancedOEPStateModel();

    public brokerStatusSupported = false;
    public oepConnectBrokerMessage = '';

    constructor(data?: any) {
        if (data) {
            ObjectHelpers.setProperties(data, this, true);
            this.selectedLineColor = new ChartStyleColorModel(data.selectedLineColor);
            this.selectedUpCandleColor = new ChartStyleColorModel(data.selectedUpCandleColor);
            this.selectedDownCandleColor = new ChartStyleColorModel(data.selectedDownCandleColor);
            this.selectedOutlineWickColor = new ChartStyleColorModel(data.selectedOutlineWickColor);
            this.selectedDateTextColor = new ChartStyleColorModel(data.selectedDateTextColor);
            this.selectedPriceTextColor = new ChartStyleColorModel(data.selectedPriceTextColor);
            this.selectedStatusLineTextColor = new ChartStyleColorModel(data.selectedStatusLineTextColor);
            this.selectedChartGradientColor = new ChartStyleColorModel(data.selectedChartGradientColor);
            this.selectedChartBackgroundColor = new ChartStyleColorModel(data.selectedChartBackgroundColor);
            this.selectedDisplayPriorDayCloseColor = new ChartStyleColorModel(data.selectedDisplayPriorDayCloseColor);
            this.watermarkColor = new ChartStyleColorModel(data.watermarkColor);
            this.preMarketColor = new ChartStyleColorModel(data.preMarketColor);
            this.postMarketColor = new ChartStyleColorModel(data.postMarketColor);
            this.earningRectangleColor = new ChartStyleColorModel(data.earningRectangleColor);

            if (data.marketingChartAreaFillHexColor) {
                this.marketingChartAreaFillHexColor = new ChartStyleColorModel(data.marketingChartAreaFillHexColor);
            }

            if (data.marketingChartGradientHexColor) {
                this.marketingChartGradientHexColor = new ChartStyleColorModel(data.marketingChartGradientHexColor);
            }
            
            if (data.chartStylePIPSettings) {
                this.chartStylePIPSettings = new ChartStylePIPSettingsModel(data.chartStylePIPSettings);
            }

            if (data.timeframeColor) {
                this.timeframeColor = new ChartStyleColorModel(data.timeframeColor);
            }

            if (data.singleStockInfoBackgroundColor) {
                this.singleStockInfoBackgroundColor = new ChartStyleColorModel(data.singleStockInfoBackgroundColor);
            }

            if (data.selectedAreaChartUpColor) {
                this.selectedAreaChartUpColor = new ChartStyleColorModel(data.selectedAreaChartUpColor);
            }

            if (data.selectedAreaChartDownColor) {
                this.selectedAreaChartDownColor = new ChartStyleColorModel(data.selectedAreaChartDownColor);
            }

            if (data.chartSettingsJson) {
                try {
                    const chartSettingsPopupModel = JSON.parse(data.chartSettingsJson);
                    this.chartSettingsPopupModel = new ChartSettingsPopupModel(ObjectHelpers.toCamel(chartSettingsPopupModel));
                } catch {}
            }

            if (data.displayChartSettingZoomAndScroll) {
                this.chartSettingsPopupModel.displayChartSettingZoomAndScroll = data.displayChartSettingZoomAndScroll;
            } else {
                this.chartSettingsPopupModel.displayChartSettingZoomAndScroll = false;
            }
            
            if (this.tradeOrderEntrySupported && this.tradeOrderEntryEnabled) {
                if (data.defaultEnableTradeOrderEntry) {
                    this.chartSettingsPopupModel.defaultEnableTradeOrderEntry = data.defaultEnableTradeOrderEntry;
                } 
            } else {
                this.chartSettingsPopupModel.defaultEnableTradeOrderEntry = false;
            }

            if (data.yAxisStateJson) {
                try {
                    this.chartYAxisStateModel = JSON.parse(data.yAxisStateJson);
                } catch {}
            }

            if (data.advancedOEPStateJson) {
                try {
                    const advancedOEPStateModel = JSON.parse(data.advancedOEPStateJson);
                    this.advancedOEPStateModel = new AdvancedOEPStateModel(ObjectHelpers.toCamel(advancedOEPStateModel));
                } catch {}
            }

            if (typeof data.emaCloudDisplayOnlyLastTwoTrades === 'undefined') {
                const val = localStorage.getItem('TEMP_EMACloudDisplayOnlyLastTwoTrades');
                if (val) {
                    this.emaCloudDisplayOnlyLastTwoTrades = val == 'true';
                }
            }

            if (typeof data.emaCloudDisplayBuySellFlags === 'undefined') {
                const val = localStorage.getItem('TEMP_EMACloudDisplayBuySellFlags');
                if (val) {
                    this.emaCloudDisplayBuySellFlags = val == 'true';
                }
            }
        }
    }

    public nonNormalChartMode(): boolean {
        return this.primitiveMode || this.advancedOEPPopoutMode;
    }

    public getChangeFromCloseUpColor(): string {
        if (this.isDarkTheme) {
            return this.changeFromCloseUpColorDark;
        }

        return this.changeFromCloseUpColorLight;
    }

    public getChangeFromCloseDownColor(): string {
        if (this.isDarkTheme) {
            return this.changeFromCloseDownColorDark;
        }

        return this.changeFromCloseDownColorLight;
    }

    public getLastPriceUpColor(): string {
        if (this.isDarkTheme) {
            return this.lastPriceUpColorDark;
        }

        return this.lastPriceUpColorLight;
    }

    public getLastPriceDownColor(): string {
        if (this.isDarkTheme) {
            return this.lastPriceDownColorDark;
        }

        return this.lastPriceDownColorLight;
    }    

    public equals(toCompare: ChartStyleSettingsModel): boolean {
        const currentValue = ObjectHelpers.copy(this);
        currentValue.watermarkColor = null;
        currentValue.watermarkOpacity = null;
        currentValue.crossHairsEnabled = null;
        currentValue.gridLinesEnabled = null;
        currentValue.preMarketColor = null;
        currentValue.postMarketColor = null;
        currentValue.showWatermark = null;
        currentValue.curvedLineDisabled = null;
        currentValue.getPrePostLastPriceDisabled = null;
        currentValue.startDrawingToolsExpanded = null;
        currentValue.highChartIndicatorsEnabled = null;
        currentValue.extraFutureBarCount = null;
        currentValue.zoomLevel = null;
        currentValue.startTimeT = null;
        currentValue.emojiDrawingToolsEnabled = null;
        currentValue.emojiDefaultSize = null;
        currentValue.emojiFontSizes = null;
        currentValue.pnpPosition = null;
        currentValue.pnpExpanded = null;
        currentValue.pnpInitialed = null;
        currentValue.pnpEnabled = null;
        currentValue.pnpPriceAlertEnabled = null;
        currentValue.pnpChangePercentEnabled = null;
        currentValue.goLevelColors = null;
        currentValue.marketingChartAreaFillHexColor = null;
        currentValue.marketingChartGradientHexColor = null;
        currentValue.singleStockBaseColor = null;
        currentValue.singleStockState = null;
        currentValue.singleStockSupported = null;
        currentValue.singleStockEnabled = null;
        currentValue.singleStockNoBackground = null;
        currentValue.singleStockAutoCollapseHeight = null;
        currentValue.singleStockBGPercent = null;
        currentValue.singleStockSeparatorPercent = null;
        currentValue.changeFromCloseUpColorLight = null;
        currentValue.changeFromCloseDownColorLight = null;
        currentValue.changeFromCloseUpColorDark = null;
        currentValue.changeFromCloseDownColorDark = null;
        currentValue.smallChartChangeHeight = null;
        currentValue.smallChartChangeWidth = null;
        currentValue.chartStylePIPSettings = null;
        currentValue.decimalSeparator = null;
        currentValue.thousandSeparator = null;
        currentValue.timeframeColor = null;
        currentValue.singleStockInfoBackgroundColor = null;
        currentValue.previewChartBackgroundTrasparent = null;
        currentValue.selectedAreaChartUpColor = null;
        currentValue.selectedAreaChartDownColor = null;
        currentValue.highChartIndicators = null;
        currentValue.supportsFutureScrolling = null;
        currentValue.rightEdgePaddingSaveEnabled = null;
        currentValue.futureScrollingEnabled = null;
        currentValue.futureScrollingBarCount = null;
        currentValue.futureScrollingMinDisplayBarCount = null;
        currentValue.zoomEnabled = null;
        currentValue.newTradeUIEnabled = null;
        currentValue.newTradeUITop = null;
        currentValue.newTradeUILeft = null;
        currentValue.newTradeUIOpen = null;
        currentValue.newTradeUIType = null;
        currentValue.newTradeUITif = null;
        currentValue.newTradeUIAccount = null;
        // currentValue.newTradeUIQuantity = null;
        currentValue.pnpTimeframeRangeEnabled = null;
        currentValue.futureScrollingScrollStopEnabled = null;
        currentValue.mobileZoomEnabled = null;
        currentValue.marketingChartTimeframeAutoExpand = null;
        currentValue.exitOrderDisplayBluePlotline = null;
        currentValue.emaCloudEnabled = null;
        currentValue.emaCloudCount = null;
        currentValue.zoomAndScrollEnabled = null;
        currentValue.zoomAndScrollAbsoluteHeight = null;
        currentValue.rightEdgePaddingBarsDefault = null;
        currentValue.chartYAxisStateModel = null;
        currentValue.yAxisStateJson = null;
        currentValue.chartSettingsJson = null;
        
        const toCompareValue = ObjectHelpers.copy(toCompare);
        toCompareValue.watermarkColor = null;
        toCompareValue.watermarkOpacity = null;
        toCompareValue.crossHairsEnabled = null;
        toCompareValue.gridLinesEnabled = null;
        toCompareValue.preMarketColor = null;
        toCompareValue.postMarketColor = null;
        toCompareValue.showWatermark = null;
        toCompareValue.curvedLineDisabled = null;
        toCompareValue.getPrePostLastPriceDisabled = null;
        toCompareValue.startDrawingToolsExpanded = null;
        toCompareValue.highChartIndicatorsEnabled = null;
        toCompareValue.extraFutureBarCount = null;
        toCompareValue.zoomLevel = null;
        toCompareValue.startTimeT = null;
        toCompareValue.emojiDrawingToolsEnabled = null;
        toCompareValue.emojiDefaultSize = null;
        toCompareValue.emojiFontSizes = null;
        toCompareValue.pnpPosition = null;
        toCompareValue.pnpExpanded = null;
        toCompareValue.pnpInitialed = null;
        toCompareValue.pnpEnabled = null;
        toCompareValue.pnpPriceAlertEnabled = null;
        toCompareValue.pnpChangePercentEnabled = null;
        toCompareValue.goLevelColors = null;
        toCompareValue.marketingChartAreaFillHexColor = null;
        toCompareValue.marketingChartGradientHexColor = null;
        toCompareValue.singleStockBaseColor = null;
        toCompareValue.singleStockState = null;
        toCompareValue.singleStockSupported = null;
        toCompareValue.singleStockEnabled = null;
        toCompareValue.singleStockNoBackground = null;
        toCompareValue.singleStockAutoCollapseHeight = null;
        toCompareValue.singleStockBGPercent = null;
        toCompareValue.singleStockSeparatorPercent = null;
        toCompareValue.changeFromCloseUpColorLight = null;
        toCompareValue.changeFromCloseDownColorLight = null;
        toCompareValue.changeFromCloseUpColorDark = null;
        toCompareValue.changeFromCloseDownColorDark = null;
        toCompareValue.smallChartChangeHeight = null;
        toCompareValue.smallChartChangeWidth = null;
        toCompareValue.chartStylePIPSettings = null;
        toCompareValue.decimalSeparator = null;
        toCompareValue.thousandSeparator = null;
        toCompareValue.timeframeColor = null;
        toCompareValue.singleStockInfoBackgroundColor = null;
        toCompareValue.previewChartBackgroundTrasparent = null;
        toCompareValue.selectedAreaChartUpColor = null;
        toCompareValue.selectedAreaChartDownColor = null;
        toCompareValue.highChartIndicators = null;
        toCompareValue.supportsFutureScrolling = null;
        toCompareValue.rightEdgePaddingSaveEnabled = null;
        toCompareValue.futureScrollingEnabled = null;
        toCompareValue.futureScrollingBarCount = null;
        toCompareValue.futureScrollingMinDisplayBarCount = null;
        toCompareValue.zoomEnabled = null;
        toCompareValue.newTradeUIEnabled = null;
        toCompareValue.newTradeUITop = null;
        toCompareValue.newTradeUILeft = null;
        toCompareValue.newTradeUIOpen = null;
        toCompareValue.newTradeUIType = null;
        toCompareValue.newTradeUITif = null;
        toCompareValue.newTradeUIAccount = null;
        // toCompareValue.newTradeUIQuantity = null;
        toCompareValue.pnpTimeframeRangeEnabled = null;
        toCompareValue.futureScrollingScrollStopEnabled = null;
        toCompareValue.mobileZoomEnabled = null;
        toCompareValue.marketingChartTimeframeAutoExpand = null;
        toCompareValue.exitOrderDisplayBluePlotline = null;
        toCompareValue.emaCloudEnabled = null;
        toCompareValue.emaCloudCount = null;
        toCompareValue.zoomAndScrollEnabled = null;
        toCompareValue.zoomAndScrollAbsoluteHeight = null;
        toCompareValue.rightEdgePaddingBarsDefault = null;
        toCompareValue.chartYAxisStateModel = null;
        toCompareValue.yAxisStateJson = null;
        toCompareValue.chartSettingsJson = null;

        // console.log('currentValue', JSON.stringify(currentValue))
        // console.log('toCompareValue', JSON.stringify(toCompareValue))
        return JSON.stringify(currentValue) == JSON.stringify(toCompareValue);
    }
}